import type { ValidationDiagnostic } from '@/lib/writer/structured';

export type WriterDiagnosticSeverity = 'problem' | 'warning';

const WARNING_CODES = new Set<ValidationDiagnostic['code']>([
  'missing_label',
  'uncited_bib_entry',
]);

export function writerDiagnosticSeverity(
  diagnostic: ValidationDiagnostic,
): WriterDiagnosticSeverity {
  return WARNING_CODES.has(diagnostic.code) ? 'warning' : 'problem';
}

export function splitWriterDiagnostics(diagnostics: ValidationDiagnostic[]) {
  const problems: ValidationDiagnostic[] = [];
  const warnings: ValidationDiagnostic[] = [];

  for (const diagnostic of diagnostics) {
    if (writerDiagnosticSeverity(diagnostic) === 'warning') warnings.push(diagnostic);
    else problems.push(diagnostic);
  }

  return { problems, warnings };
}

export function countWriterDiagnostics(diagnostics: ValidationDiagnostic[]) {
  const { problems, warnings } = splitWriterDiagnostics(diagnostics);
  return { problemCount: problems.length, warningCount: warnings.length };
}